import { WorkspaceMember } from "@common/types/workspace";
import { validateManageWorkspaceAssignment } from "@common/helpers/workspacePermissions";
import { useCurrentUserWorkspaceMember } from "./useCurrentUserWorkspaceMember";

export function useCanManageWorkspaceAssignment(
    memberToManage: WorkspaceMember,
) {
    const currentMember = useCurrentUserWorkspaceMember();

    if (!currentMember) {
        return false;
    }

    return !validateManageWorkspaceAssignment(currentMember, memberToManage);
}
